import React, { useEffect, useState } from "react";
import { Container, Card, Spinner, ListGroup } from "react-bootstrap";
import axios from "axios";
import API_BASE_URL from "../config";
import { useNavigate } from "react-router-dom";

export default function SelectBranchPage() {
  const [branches, setBranches] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const company = JSON.parse(localStorage.getItem("selectedCompany"));

  useEffect(() => {
    if (!company) {
      navigate("/select-company");
      return;
    }

    async function loadBranches() {
      try {
        const res = await axios.get(`${API_BASE_URL}/companies/${company.id}/branches`);
        const data = res.data || [];
        setBranches(data);
      } catch {
        alert("Failed to load branches");
      } finally {
        setLoading(false);
      }
    }
    loadBranches();
  }, [company, navigate]);

  const handleSelectBranch = (b) => {
    localStorage.setItem("selectedBranch", JSON.stringify(b));
    navigate("/manage-company-bookings");
  };

  if (loading) return <Spinner animation="border" />;

  return (
    <Container className="py-4">
      <Card className="shadow-sm">
        <Card.Body>
          <Card.Title>Select a Branch</Card.Title>
          <ListGroup>
            {branches.map((b) => (
              <ListGroup.Item
                key={b.id}
                action
                onClick={() => handleSelectBranch(b)}
              >
                <strong>{b.name}</strong> <br />
                <small>{b.address}</small>
              </ListGroup.Item>
            ))}
          </ListGroup>
        </Card.Body>
      </Card>
    </Container>
  );
}